module.exports = __webpack_public_path__ + "static/media/pu-back.478fb414.ogg";